import {ActionType} from "typesafe-actions";
import {loadScene} from "../../../routing/actions";
import IAnalyticsAction from "../IAnalyticsAction";
import {AppScene} from "../../../routing/AppScene";

function getActionObject(scene: AppScene) {
    switch (scene) {
        case 'LevelMap': return "play";
        case 'LevelSelection': return "play";
        case 'Profile': return "profile";
        case 'History': return "history";
        case 'Leaderboards': return "leaderboards";
        case 'Store': return "store";
    }
}

export default function loadSceneHandler(action: ActionType<typeof loadScene.request>): IAnalyticsAction | undefined {
    if (action.meta !== "main_menu")
        return;

    const object = getActionObject(action.payload);
    if (!object)
        return;

    return {
        category: "game",
        object: object,
        name: "click",
    };
}